import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ParameterData,
  ParametersDataResponseRequest,
} from 'src/app/pages/admin-manager/parameters/models/parameters.model';
import { environment } from 'src/environments/environment';
import { GLOBAL_HEADERS } from 'src/app/store/store.constants';

@Injectable({ providedIn: 'root' })
export class ParametersApiService {
  private baseUrl = environment.APIM + environment.newOrderAPI;

  constructor(private http: HttpClient) {}

  getMultipleParametersByDetails(parameterList: ParametersDataResponseRequest[]): Observable<ParameterData[]> {
    return this.http
      .post<ParameterData[]>(`${this.baseUrl}Parameter/GetParametersData/`, parameterList, {
        ...GLOBAL_HEADERS,
        responseType: 'json',
      })
      .pipe(map((response) => response ?? [])); // 204 No Content has a null body; the reducer spreads it
  }
}
